import { BaseResponse } from './base-response.model';
import { DateTimeUtility } from '../utility/date-time.utility';
import { TravelItinerary } from './travel-itinerary.model';

export const REQUEST_STATUS_PENDING_MANAGER = 'Pending - Manager';
const REQUEST_STATUS_PENDING_FINANCE = 'Pending - Finance';

export class ApprovalsResponse extends BaseResponse {
	constructor(
		public message: string,
		public approvals: ApprovalJSON[]
	) {
		super(message);
	}
}

export interface ApprovalJSON {
	id: number;
	type: string;
	requestStatus: string;
	departureDate: string;
	returnDate: string;
	travelLocation: string;
	userId: number;
	traveler: string;
	requestedBy: string;
	requestedOn: string;
	manager: string;
	approvalDttm: string;
	approved: boolean;
	currentlyLocated: string;
	chartString: string;
	chargedDepartment: string;
	chargedProject: string;
}

export class Approval {
	constructor(
		public id: number,
		public type: string,
		public requestStatus: string,
		public departureDate: Date,
		public returnDate: Date,
		public travelLocation: string,
		public userId: number,
		public traveler: string,
		public requestedBy: string,
		public requestedOn: Date,
		public manager: string,
		public approvalDttm: Date,
		public approved: boolean,
		public currentlyLocated: string,
		public chartString: string,
		public chargedDepartment: string,
		public chargedProject: string
	) {}

	static fromJSON(json: ApprovalJSON): Approval {
		const approval = Object.create(Approval.prototype);
		return Object.assign(approval, json, {
			departureDate: json.departureDate
				? DateTimeUtility.fromDatabaseDate(json.departureDate)
				: null,
			returnDate: json.returnDate
				? DateTimeUtility.fromDatabaseDate(json.returnDate)
				: null,
			requestedOn: json.requestedOn
				? DateTimeUtility.fromDatabaseDatetime(json.requestedOn)
				: null,
			approvalDttm: json.approvalDttm
				? DateTimeUtility.fromDatabaseDatetime(json.approvalDttm)
				: null,
			approved: !!json.approved,
		});
	}

	static fromItinerary(itinerary: TravelItinerary): Approval {
		const approval = Object.create(Approval.prototype);
		return Object.assign(approval, {
			id: itinerary.id,
			type: itinerary.type,
			requestStatus: itinerary.requestStatus,
			departureDate: itinerary.departureDate,
			returnDate: itinerary.returnDate,
			travelLocation: itinerary.travelLocation,
			userId: itinerary.userId,
			traveler: itinerary.traveler,
			chartString: itinerary.chartString,
			chargedDepartment: itinerary.chargedDepartment,
			chargedProject: itinerary.chargedProject,
		});
	}

	isFinanceApproval(): boolean {
		return this.requestStatus === REQUEST_STATUS_PENDING_FINANCE;
	}
}
